import { render } from "./PreferredSkillsDataTable.vue?vue&type=template&id=1b8459ca&scoped=true"
import script from "./PreferredSkillsDataTable.vue?vue&type=script&lang=js"
export * from "./PreferredSkillsDataTable.vue?vue&type=script&lang=js"

import "./PreferredSkillsDataTable.vue?vue&type=style&index=0&id=1b8459ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8459ca"]])

export default __exports__